import { GET_ACCOUNT_INFORMATION, getAccountInformationSuccess } from './account-information.actions';
import { getAccountInformation } from './account-information.api';
import { EMPTY, from, of } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import Global from '../../store/global-selectors';
import { ShowSpendingLimitNotification } from '../../components/notifications/spending-limit-notification';
import { Segment } from '../../services/analytics-services/segment';
import { FUNDING_BLOCKED_BY_SPENDING_LIMIT } from '../../constants/analytics-events';

export const getAccountInformationEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(GET_ACCOUNT_INFORMATION),
    mergeMap((action) => {
      return from(getAccountInformation()).pipe(
        mergeMap((response) => {
          const state = getState();
          const isWalletAndApBacked = response?.data?.isWalletCreatedAfterAPLaunch;
          const homeCountry = Global.selectSellerHomeCountry(state);
          const sellerEmail = Global.selectSellerEmail(state);
          const { email } = Global.selectUserCurrentUserInfo(state);
          const accountInformation = response?.data || {};
          if (isWalletAndApBacked && action.shouldShowNotification) {
            ShowSpendingLimitNotification({
              homeCountry,
              result: accountInformation,
            });
            if (accountInformation.trustLevel !== 'Trusted' && accountInformation.trustLevel !== undefined) {
              Segment.trackEvent(FUNDING_BLOCKED_BY_SPENDING_LIMIT, {
                ...accountInformation,
                sellerEmail,
                userEmail: email,
              });
            }
          }
          return of(getAccountInformationSuccess(accountInformation));
        }),
        catchError(() => {
          return EMPTY;
        }),
      );
    }),
  );
};
